// We manually build Livewire assets in order to avoid unwanted behavior on K8s infrastructure
// See more @ https://livewire.laravel.com/docs/installation#manually-bundling-livewire-and-alpine

import { Livewire } from '../../../../vendor/livewire/livewire/dist/livewire.esm'

import { installErrorDialogShowModalGuard } from '../utils/LivewireErrorDialogGuard'

class LivewireVendor {
    static init() {
        installErrorDialogShowModalGuard()
        Livewire.start()
    }
}

export default LivewireVendor
